




















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { perRoadStore } from '@/store/store';
import { UnitSystem } from '@/interfaces/units';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import {
  ILayerPerformanceCriteriaImperial,
  ILayerPerformanceCriteriaMetric,
} from '@/modules/perRoad/interfaces/perRoad';
import PrSurfaceDeflectionPlot from '@/modules/perRoad/views/components/criteria/plots/PrSurfaceDeflectionPlot.vue';


const echarts = require('echarts');

@Component({
  components: {
    PrSurfaceDeflectionPlot,
    PxNumberInput,
  },
})
export default class PrSurfaceDeflection extends Vue {
  @Prop() performanceCriteria!: ILayerPerformanceCriteriaImperial | ILayerPerformanceCriteriaMetric

  @Prop() id!: number;

  get unitSystemIsImperial() {
    return perRoadStore.displayUnits === UnitSystem.Imperial;
  }

  plotKey = 0;

  sync() {
    this.$emit('sync');
    this.plotKey += 1;
  }

  mounted() {
  }

  updated() {
  }
}
